import { Controller } from "@hotwired/stimulus"

// Toggle elements' visibility with a class name. Initialise visibility with a
// `visibile` value. Use a "sticky" target to let elements show once and
// remain visible.
// Actions:
//   toggle - invert the visibility of all "togglee" targets
//   switch - show only the target items with a switch attribute containing
//            the value of the triggering element (e.g. a radio button)
export default class extends Controller {
  static targets = ["sticky", "switcher", "togglee"]
  static values = {
    className: { type: String, default: "hidden" },
    focusOnShow: { type: Boolean, default: true },
    visible: { type: Boolean, default: true },
  }

  stickyTargetConnected(element) {
    if (this.visibleValue == false) this.#hide(element)
  }

  switcherTargetConnected(element) {
    if (
      element.nodeName != "SELECT" &&
      !element.checked &&
      !element.dataset.checked &&
      !element.selected
    )
      return

    this.toggleeTargets.forEach((item) =>
      this.#switch(item, element.value ?? element.dataset.value),
    )
  }

  toggleeTargetConnected(element) {
    if (this.visibleValue == false) this.#hide(element)
  }

  toggle(e) {
    e.preventDefault()
    this.visibleValue = !this.visibleValue
    this.toggleeTargets.forEach((item) => this.#toggle(item))
    this.stickyTargets.forEach((item) => this.#show(item))
  }

  switch(e) {
    e.preventDefault()

    this.toggleeTargets.forEach((item) =>
      this.#switch(item, e.target.value ?? e.target.dataset.value),
    )
  }

  #hide(element) {
    element.classList.add(this.classNameValue)
  }

  #show(element) {
    element.classList.remove(this.classNameValue)
    this.#focus()
  }

  #toggle(element) {
    element.classList.toggle(this.classNameValue)
    if (!element.classList.contains(this.classNameValue)) this.#focus()
  }

  #switch(element, value) {
    if (!element.dataset.switch) return

    if (element.dataset.switch.split(" ").includes(value)) {
      this.#show(element)
    } else {
      this.#hide(element)
    }
  }

  #focus() {
    if (this.focusOnShowValue == false) return

    const input = this.element.querySelector("input[type='text'], textarea")
    if (!input) return

    const value = input.value
    input.focus()
    input.value = ""
    input.value = value
    input.scrollTop = 99999
  }
}
